module.exports = __webpack_public_path__ + "img/516.3c9ff9a1.jpg";